/// <amd-module name="Agile/Directory/Components/DirectoryGrid/DirectoryGridConstants" />
export namespace DirectoryColumnKeys {
    export const Name = "Name";
    export const Team = "Team";
}

export namespace DirectoryCSS {
    export const DIRECTORY_ROWITEM = "directory-rowitem";
    export const DIRECTORY_GROUP_SPACER = "directory-group-spacer";
    export const DIRECTORY_COLUMN = "directory-column";
    export const DIRECTORY_COLUMN_HEADER = "directory-column-header";
    export const DIRECTORY_DELETED_FAVORITE_CONTAINER = "directory-deleted-favorite-container";
}
